import { Inject, Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import { IS_BROWSER, IS_MOBILE } from '@app/modules/core/tokens/app.tokens';
import { MIN_WIDTH_MOBILE } from '@app/constants/navigator.constants';

@Injectable({
  providedIn: 'root'
})
export class MobileDeviceService {

  public isMobileDeviceSubject$: BehaviorSubject<boolean> = new BehaviorSubject(
    typeof window !== 'undefined' ? window && window?.innerWidth <= MIN_WIDTH_MOBILE : false);

  private isAndroid: boolean;
  private isiPad: boolean;
  private isiPhone: boolean;
  private isiPod: boolean;
  private isiDevice: boolean;
  private isWebOS: boolean;
  private isWindowsPhone: boolean;
  private isSamsungBrowser: boolean;
  private isMobileSafariBrowser: boolean;

  constructor(
    @Inject(IS_BROWSER) private isBrowser: boolean,
    @Inject(IS_MOBILE) public isMobile: boolean
  ) {
    if (this.isBrowser) {
      this.isiPad = this.testRegex(/ipad/i);
      this.isiPod = this.testRegex(/ipod/i);
      this.isWebOS = this.testRegex(/webos/i);
      this.isiPhone = this.testRegex(/iphone/i);
      this.isAndroid = this.testRegex(/android/i);
      this.isiDevice = this.testRegex(/ipad|iphone|ipod/i);
      this.isWindowsPhone = this.testRegex(/windows phone/i);
      this.isSamsungBrowser = this.testRegex(/SamsungBrowser/i);
      this.isMobileSafariBrowser = this.testRegex(/mobile safari/i);
      if (typeof window === 'undefined' || !window) return;
      window.addEventListener('resize', this.OnResize.bind(this));
    }
  }

  get isMobileDevice$(): Observable<boolean> {
    return this.isMobileDeviceSubject$.asObservable().pipe(map(isMobileDevice => this.isMobile || isMobileDevice));
  }

  get isMobileAgent(): boolean {
    return this.isAndroid || this.isiPad || this.isiPhone || this.isiPod || this.isiDevice
      || this.isWebOS || this.isWindowsPhone || this.isSamsungBrowser || this.isMobileSafariBrowser;
  }

  public isAndriodPhone(): boolean {
    return this.isAndroid;
  }

  public isIosPhone(): boolean {
    return this.isiPhone || this.isiPad || this.isiPod || this.isWebOS;
  }

  private testRegex(regex: RegExp): boolean {
    return regex.test(navigator.userAgent.toLowerCase());
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private OnResize(event: any): void {
    this.isMobileDeviceSubject$.next(this.isMobile || event.target.innerWidth <= MIN_WIDTH_MOBILE);
  }

}
